import { render } from "./TeamDaily.vue?vue&type=template&id=66ea4671&scoped=true"
import script from "./TeamDaily.vue?vue&type=script&lang=js"
export * from "./TeamDaily.vue?vue&type=script&lang=js"

import "./TeamDaily.vue?vue&type=style&index=0&id=66ea4671&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ea4671"]])

export default __exports__